import { Directive, EventEmitter, HostListener, Output } from '@angular/core';
import * as i0 from "@angular/core";
export class DropZoneDirective {
    constructor() {
        this.fileDropped = new EventEmitter();
    }
    // Dragover listener
    onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
    }
    // Dragleave listener
    onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
    }
    /**
     * on file drop handler
     */
    onFileDrop(event) {
        event.preventDefault();
        event.stopPropagation();
        const { dataTransfer } = event;
        if (dataTransfer === null || dataTransfer === void 0 ? void 0 : dataTransfer.items) {
            const files = [];
            const dataListItem = Array.from(dataTransfer === null || dataTransfer === void 0 ? void 0 : dataTransfer.items).map((item) => item);
            dataListItem.forEach((item) => {
                if (item.kind === 'file') {
                    const file = item.getAsFile();
                    if (file) {
                        files.push(file);
                    }
                }
            });
            dataTransfer.items.clear();
            this.fileDropped.emit(files);
        }
    }
}
DropZoneDirective.ɵfac = function DropZoneDirective_Factory(t) { return new (t || DropZoneDirective)(); };
DropZoneDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: DropZoneDirective, selectors: [["", "mheDropZone", ""]], hostBindings: function DropZoneDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("dragover", function DropZoneDirective_dragover_HostBindingHandler($event) { return ctx.onDragOver($event); })("dragleave", function DropZoneDirective_dragleave_HostBindingHandler($event) { return ctx.onDragLeave($event); })("drop", function DropZoneDirective_drop_HostBindingHandler($event) { return ctx.onFileDrop($event); });
    } }, outputs: { fileDropped: "fileDropped" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropZoneDirective, [{
        type: Directive,
        args: [{
                selector: '[mheDropZone]',
            }]
    }], null, { fileDropped: [{
            type: Output
        }], onDragOver: [{
            type: HostListener,
            args: ['dragover', ['$event']]
        }], onDragLeave: [{
            type: HostListener,
            args: ['dragleave', ['$event']]
        }], onFileDrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }] }); })();
